import React from 'react';
import { UseFormReturn } from 'react-hook-form';

import { UiTypography } from '@/components/ui/Typography';
import { ApiUserType } from '@/modules/api';

import { CATEGORIES_SETUP } from '../../constants';
import { OnboardingParamsTool } from '../../utils/paramsTool';

import {
  PreferencesListV3ItemStyles,
  PreferencesListV3Styles,
} from './V3.styles';

export const PreferencesListV3: React.FC<{
  preloadCategories: ApiUserType['selected_categories'];
  categories: string[];
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  form: UseFormReturn<any>;
}> = ({ preloadCategories, categories, form }) => {
  return (
    <PreferencesListV3Styles>
      {preloadCategories &&
        preloadCategories.map((option) => {
          const selected = categories?.includes(option.id);
          const aiNumber =
            option.id in CATEGORIES_SETUP
              ? CATEGORIES_SETUP[option.id].number
              : 849;

          return (
            <PreferencesListV3ItemStyles
              key={option.id}
              imageSrc={option.background_picture?.v3 || ''}
              selected={selected}
              onClick={() => {
                const fieldValues = form.getValues('categories');

                const hasFormValue = fieldValues.includes(option.id);

                const copiedCategories = [...categories];

                if (hasFormValue) {
                  form.setValue(
                    'categories',
                    fieldValues.filter((x: string) => x !== option.id),
                  );
                  copiedCategories.splice(
                    copiedCategories.indexOf(option.id),
                    1,
                  );
                } else {
                  form.setValue('categories', [...fieldValues, option.id]);
                  copiedCategories.push(option.id);
                }

                OnboardingParamsTool.setParam('categories', copiedCategories);
              }}
            >
              <div>
                <UiTypography align="center" variant="body-large">
                  {option.title}
                </UiTypography>
                <UiTypography
                  align="center"
                  color="neutral-black"
                  variant="body-medium"
                >
                  {aiNumber} AIs
                </UiTypography>
              </div>
            </PreferencesListV3ItemStyles>
          );
        })}
    </PreferencesListV3Styles>
  );
};
